// @flow
import React from 'react';

import ForcesContainer from '../containers/ForcesContainer';

const HinderingForcesContainer = () => (
  <ForcesContainer submitButtonText="Create Hindering Force" driving={false} />
);

export default HinderingForcesContainer;



// WEBPACK FOOTER //
// ./src/components/HinderingForcesContainer.js